import { useParams } from "react-router-dom";
import QuizTable from "./components/QuizTable";
import Header from "../components/Header";
import Button from "../../../components/Button";
import usePermission from "../../../hooks/usePermission";

function QuizPage() {
    const { canAll } = usePermission();

    const { courseId, lectureId, itemId } = useParams();
    let pagesLinks = [
        {
            name: "اسألة الأختبار",
            link: `/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}`,
        },

        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },
        {
            name: "محتويات المحاضره",
            link: `/admin/courses/${courseId}/lectures/${lectureId}`,
        },
    ];

    return (
        <div className="py-5">
            <Header
                pageName="اسألة الأختبار"
                pages={pagesLinks}
                className="py-3 text-2xl"
            />
            {canAll([
                "read:course:lecture:quiz:quiestions",
                "read:course:lecture:quiz:quiestion:options",
            ]) && (
                    <Button
                        type="primary"
                        className="rounded-lg"
                        to={`/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/view`}
                    >
                        عرض الأسالة و الاجابات
                    </Button>
                )}
            <QuizTable />
        </div>
    );
}

export default QuizPage;
